// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1zhqH","boxTitle":"Qualiphy_boxTitle__1mDkD","box":"Qualiphy_box__2p2G8","toggleWrap":"Qualiphy_toggleWrap__1e6Hz"};